"use strict";

var _moduleLocalization = require("@eig-builder/module-localization");

_moduleLocalization.Localizations.append({
  imagepicker: {
    wordpressImages: 'WordPress images',
    logos: 'Logos',
    title: 'Image library',
    selectImage: 'Choose an image',
    noLogosYet: 'You currently do not have any logos',
    createLogo: 'Create Logo',
    myImages: 'My images',
    freeImages: 'Free images',
    stockPhotos: 'Stock photos',
    unsplash: 'Unsplash',
    unsplashCopyright: 'This image is provided by Unsplash. By using it, you agree to comply with Unsplash\'s terms.',
    unsplashCopyrightWithValue: 'This image is provided by Unsplash. By using it, you agree to comply with {terms}',
    copyrightText: 'By using this image you agree to comply with the following {terms}.',
    freeVideos: 'Free videos',
    addImages: 'Add images',
    favorites: 'Favorites',
    addedToFavorites: 'Added to favorites',
    imageDetails: 'Image details',
    imageDetailsZoom: 'Zoom',
    drophovermessage: 'Drop files to upload them to {0}',
    uploadsuccess: 'File(s) successfully uploaded to {0}',
    dragndrop: 'Drag & drop files here',
    browsefiles: 'Browse files',
    addmorefiles: 'Add more files',
    socialmessage: 'Pick images from your {0} account',
    sociallogin: 'Connect to {0}',
    loading: 'Loading',
    savingImage: 'Saving image...',
    uploading: 'Uploading',
    noImagesFound: 'No images found. Try to search for another term...',
    noImagesYet: 'No images found.',
    searchOnUnsplash: 'Search on Unsplash',
    searchForImages: 'Search for images',
    uploadingNumFiles: 'Uploading {0} {1}',
    uploadComplete: 'Upload complete',
    uploadCompleteWithErrors: 'Uploads complete (with errors)',
    uploadErrors: 'Error occurred during upload',
    uploadError: 'Error occured during upload: {0}',
    fileExceedsSizeLimit: 'File exceeds {0} limit',
    fileExceedsSizeLimit2: "Wow! That's a big file..., Unfortunately there is a {0} size limit per image...",
    fileNotSupported: 'This file type is not supported',
    notAFile: 'This is not a file',
    upload: 'Upload',
    facebook: 'Facebook',
    yelp: 'Yelp',
    save: 'Save',
    author: 'Photo by:',
    authorMultiple: 'Photos by:',
    moreFromUser: 'more by this author',
    resolution: 'Resolution',
    use: 'Use image',
    useImage: 'Apply',
    editImage: 'Edit',
    dimensions: 'Dimensions',
    deleteImages: {
      title: 'Are you sure?',
      content: 'Are you sure you want to delete this image from My Images? This will also remove the image from your website in case it is being used.',
      contentMultiple: 'Are you sure you want to delete these images from My Images? This will also remove the images from your website in case they are being used.',
      footerButtonYes: 'Yes',
      footerButtonNo: 'No',
      amountWillBeDeleted: '{amount} image will be deleted from your site.',
      amountWillBeDeletedMultiple: '{amount} images will be deleted from your site.'
    },
    editImages: {
      resetEffects: 'Reset colors',
      titleColors: 'Colors',
      ratioTitle: 'Sizing',
      ratioOriginal: 'Original',
      ratioSquare: 'Square',
      ratioPortrait: 'Portrait',
      ratioThreeByTwo: '3:2',
      ratioSixteenByNine: '16:9',
      ratioSevenByFive: '7:5'
    },
    enterLink: 'Enter image link',
    noValidImage: 'No valid image source',
    addFromLinkPlaceholder: 'E.g. http://images.com/landscape.jpg',
    maxSizeText1: 'Note: When uploading your own images, keep an eye on the size of your files. ',
    maxSizeText2: 'There is a {0} size limit per image.',
    maxAmountOfFilesUpload: 'You may only upload {0} files at the same time',
    "delete": 'Delete',
    cancelSearch: 'Cancel',
    showOnUnsplash: 'View on unsplash.com'
  }
});